import { authorizeGetRequest } from "api";

export interface ISystemHealth {
    status: "healthy" | "unhealthy";
    timestamp: string;
    services: {
        database: "healthy" | "unhealthy";
        mongodb: "healthy" | "unhealthy";
        redis: "healthy" | "unhealthy";
    };
}

export const getSystemHealthApi = () => {
    // Use absolute URL or relative depending on system config
    // The spec says /health, but let's assume it's under api/v1 if other endpoints are
    return authorizeGetRequest<ISystemHealth>(`health`);
};
